<div class="container">




    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

        <ng-container matColumnDef="camera">
            <th mat-header-cell *matHeaderCellDef> Caméra </th>
            <td mat-cell *matCellDef="let element"> {{element.camera}} </td>
        </ng-container>

        <ng-container matColumnDef="application">
            <th mat-header-cell *matHeaderCellDef> Application </th>
            <td mat-cell *matCellDef="let element"> {{element.application}} </td>
        </ng-container>


        <ng-container matColumnDef="lastSync">
            <th mat-header-cell *matHeaderCellDef class="header_infos"> LastSync </th>
            <td mat-cell *matCellDef="let element" class="infos">
                <fa-icon [icon]="faInfoCircle" (click)="openDialogInfoCamera(element)"></fa-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="batterie">
            <th mat-header-cell *matHeaderCellDef> battery
            </th>
            <td mat-cell *matCellDef="let element"> {{element.batterie}} </td>
        </ng-container>

        <ng-container matColumnDef="Reset">
            <th mat-header-cell *matHeaderCellDef> Reset </th>
            <td mat-cell *matCellDef="let element"> {{element.Reset}}
                <fa-icon [icon]="faRedo"></fa-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="onOff">
            <th mat-header-cell *matHeaderCellDef> Active/Inactive </th>
            <td mat-cell *matCellDef="let element"> {{element.onOff}}
                <mat-slide-toggle color="primary" [checked]="true"></mat-slide-toggle>
            </td>
        </ng-container>

        <ng-container matColumnDef="option">
            <th mat-header-cell *matHeaderCellDef>Option </th>
            <td mat-cell *matCellDef="let element">
                <fa-icon [icon]="faCogs" (click)="openDialogOptionCamera(element)"> </fa-icon>
            </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>




</div>